export const IS_LEGAL_NAME = {
  YES: 'yes',
  NO: 'no',
};
